import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsSkill = [
  { title: 'Skills', name: 'thema' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultSkill = {
  thema: '',
};

const skillValidationSchema = Yup.object().shape({
  thema: Yup.string()
    .max(50, 'Darf maximal 50 Zeichen lang sein.')
    .required('Bitte geben Sie einen Skill ein.'),
});

const SkillOverview = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [skill, setSkill] = useState({
    ...defaultSkill,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Skill | Stammdaten';
  }, []);

  useEffect(() => {
    if (skill._links !== undefined) {
      setSelfLink(skill._links.self.href);
    }

    // sets formik values
    if (formikRef.current && skill !== formikRef.current.values) {
      formikRef.current.setValues(skill);
    }
  }, [skill]);

  return (
    <div className="container-fluid">
      <ButtonCard title="Skills" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Skill"
          setEntity={setSkill}
          defaultEntity={defaultSkill}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(
            <Formik
              innerRef={formikRef}
              initialValues={skill}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.SKILLS,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={skillValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="skill-group">
                      <InputField
                        value={values.thema}
                        handleChange={handleChange}
                        touched={touched.thema}
                        errorDescription={errors.thema}
                        fieldName="thema"
                        placeholder="Skill*"
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          )}
        />
        <PagedTable
          entityName={Bivema.SKILLS}
          columns={columnsSkill}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setSkill}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default SkillOverview;
